<script setup>
import { computed, useAttrs, mergeProps } from 'vue';
import { v4 as uuidv4 } from 'uuid';

defineOptions({
    inheritAttrs: false,
});

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    id: {
        type: String,
        required: false,
        default: () => "checkbox--" + uuidv4(),
    },
    modelValue: {
        type: [Boolean, Array, Set],
        required: false,
        default: false,
    },
    inline: {
        type: Boolean,
        default: false,
    },
});

const attrs = useAttrs();

const modelValueProxy = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emit('update:modelValue', val);
    }
});

const outerAttrs = computed(() => mergeProps(
    { class: attrs.class },
    { class: { 'checkbox': true, 'checkbox-inline': props.inline } },
));

</script>

<template>
    <div v-bind="outerAttrs">
        <input
            v-bind="{ ...$attrs, class: undefined }"
            type="checkbox"
            :id="id"
            v-model="modelValueProxy"
        >
        <label :for="id">
            <slot />
        </label>
    </div>
</template>
